import { MdAdd } from 'react-icons/md'
import SuggestionTabsBlock from './SuggestionTabsBlock'
import { checkIfNameExists } from '@/components/shared/utils'
import { TAB_TYPE_DEED, TAB_TYPE_LEASE } from '@/constants'

const SuggestionTabs = ({ tabs, setTabs, setTabIdx, removeDocumentFromTab, removeTab, numOfBlocks = 2 }) => {
    
    const tabBlocks = tabs.reduce((acc, tab, i) => {
        // gambiarra: will be used for renaming and deleting
        tab.realIdx = i
        acc[i % numOfBlocks] = acc[i % numOfBlocks] || []
        acc[i % numOfBlocks].push(tab)
        
        return acc
    }, Array(numOfBlocks))
    
    const addTab = type => {
        const newTab = {
            name: checkIfNameExists(tabs, `${type.charAt(0).toUpperCase()}${type.substr(1)} - Unnamed`),
            documents: [],
            type,
        }
        
        setTabs([...tabs, newTab])
    }
    
    const renameTab = (tabIdx, newName) => {
        
        const tab = { ...tabs[tabIdx], name: checkIfNameExists(tabs, newName) }
        
        tabs[tabIdx] = tab
        
        setTabs([...tabs])
        
    }
    
    return (
        <>
            <div className="flex justify-between items-center">
                <div>
                    <h4 className="mt-4">Suggested Tabs</h4>
                    <div className="-mt-1 pb-2 text-sm text-slate-400">
                        Filter out all documents in Tabs to simplify Chaining process
                    </div>
                </div>
                <div className="dropdown dropdown-end">
                    <div tabIndex={0} role="button" className="btn btn-xs btn-ghost"><MdAdd />Add Tab</div>
                    <ul tabIndex={0} className="dropdown-content menu bg-base-100 rounded-box w-52 p-2 shadow">
                        <li><a onClick={() => addTab(TAB_TYPE_DEED)}>Add Deed Tab</a></li>
                        <li><a onClick={() => addTab(TAB_TYPE_LEASE)}>Add Leasehold Tab</a></li>
                    </ul>
                </div>
                {/* <button className="btn btn-xs btn-ghost" onClick={addTab}><MdAdd />Add Leasehold Tab</button> */}
            </div>
            <div className="max-h-[20vh] overflow-auto">
                <div className="flex gap-2 relative">
                    {tabBlocks.map((block, i) => <SuggestionTabsBlock
                        key={i}
                        block={block}
                        removeDocument={removeDocumentFromTab}
                        renameTab={renameTab}
                        removeTab={removeTab}
                        setTabIdx={setTabIdx} />)}
                </div>
            </div>
        </>
    )
}

export default SuggestionTabs